import type { GQL_ID } from '@@partner:types:graphql'
import type { Labels } from '@@partner:types:app'

import { gql, useQuery } from '@apollo/client'

export interface SingleLabelQuery {
  label: Labels
}

export interface SingleLabelQueryVariables {
  id?: GQL_ID
  style?: string
}

export const GQL_QUERY_SINGLE_LABEL = gql`
  query ($id: ID!, $style: String) {
    label: singleMarketingLabel(id: $id) {
      id
      system_name
      name
      description
      status
      sort_order
      image(style: $style) {
        url
      }
      activeFrom
      activeUntil
      optionColor
      optionBackgroundColor
      optionLink
      optionLinkLabel

      i18n {
        id
        language_code
        name
        description
        image(style: $style) {
          url
        }
        image_id
        option_link_label
      }
    }
  }
`

export const useFetchSingleLabel = ({ id }: SingleLabelQueryVariables) =>
  useQuery<SingleLabelQuery, SingleLabelQueryVariables>(
    GQL_QUERY_SINGLE_LABEL,
    {
      variables: {
        id
      },
      skip: !id,
      fetchPolicy: 'cache-and-network'
    }
  )
